<grid-engine-header-shell [params]="params()">
  <span [ngClass]="{ 'skip-text-transform': $safeNavigationMigration(params()?.skipTextTransform) }" class="customHeaderLabel">{{
    $safeNavigationMigration(params()?.displayName) | translate
  }}</span>
</grid-engine-header-shell>
